define('components/spinner/viewmodel', [
    'viewmodels/base_es5',
    'components/spinner/model',
    './template.html',
    './styles.scss',
], function (Base, Model) {
    function ViewModel(config) {
        Base.call(this, config);

        this.active = this.model.active;        
        this.height = this.model.height;
        this.inline = this.height.is(function (height) { return height > 0 });

        this.options = this.model.options;

        this.spinner = this._registerObservable(ko.pureComputed(this._getSpinner, this),
            _.noop,
            function (spinner) { spinner.stop() });

        this.realHeight = ko.pureComputed(function () { return this.active() ? this.height() : null }, this);
    }

    ViewModel.Model = Model;

    ViewModel.prototype = Object.create(Base.prototype);
    ViewModel.prototype.constructor = ViewModel;

    ViewModel.prototype.beforeInit = function () {
        Base.prototype.beforeInit.call(this);

        ko.applyBindingsToNode(this.element, {
            'visible': this.active,

            'css': {
                'spinner-new': true,
                'spinner-new--inline': this.inline
            },
            'style': {
                'height': this.realHeight.toPx(true),
                'width': this.realHeight.toPx(true)
            }
        });
    };

    ViewModel.prototype._getSpinner = function () {
        if (this.active())
            return system.initSpinner(this.element, this.options());

        return null;
    };

    return ViewModel;
});